export const howItWorks = [
    {
        heading: "Connect your wallet",
        text: "Connect your wallet using metamask by clicking on the connect button,then enter your password to metamask to continue.",
    },
    {
        heading: "Transfer funds",
        text: "Enter the reciepient details to be able to send funds, an order would be created to be able then your t",
    },
    {
        heading: "Approve transaction success",
        text: "Fund your Klasha Wallet using your local African payment methods and currencies, get access to virtual dollar cards, shop for your favourite.",
    },
]